import { render, staticRenderFns } from "./bargainDetail.vue?vue&type=template&id=0e003cb6&scoped=true&"
import script from "./bargainDetail.vue?vue&type=script&lang=js&"
export * from "./bargainDetail.vue?vue&type=script&lang=js&"
import style0 from "./bargainDetail.vue?vue&type=style&index=0&id=0e003cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e003cb6",
  null
  
)

export default component.exports